/* ─────────────────────────────────────────────────────────────────────────────
 * Cliente HTTP dos services de API.
 *
 * Deliberadamente pequeno: o site institucional so faz GET publico. Nao ha
 * autenticacao aqui, e nao deve haver — nada nesta pagina exige identidade, e
 * qualquer token embutido no bundle seria publico.
 * ────────────────────────────────────────────────────────────────────────── */

export class HttpError extends Error {
  constructor(
    readonly status: number,
    readonly url: string,
    message: string,
  ) {
    super(message)
    this.name = "HttpError"
  }
}

export interface HttpClient {
  get<T>(path: string, params?: Record<string, string | undefined>): Promise<T>
}

export function createHttpClient(baseUrl: string, timeoutMs = 10_000): HttpClient {
  if (!baseUrl) {
    // Falha na criacao, e nao na primeira requisicao. Um baseUrl vazio produz
    // fetch("/v1/planos") contra o proprio CloudFront, que devolve a index.html
    // e estoura num `JSON.parse` a tres camadas de distancia da causa real.
    throw new Error(
      "VITE_API_BASE_URL nao definida. Ela e obrigatoria quando VITE_DATA_SOURCE=api.",
    )
  }

  const root = baseUrl.replace(/\/+$/, "")

  return {
    async get<T>(path: string, params?: Record<string, string | undefined>): Promise<T> {
      const url = new URL(`${root}${path}`)

      for (const [key, value] of Object.entries(params ?? {})) {
        if (value !== undefined && value !== "") url.searchParams.set(key, value)
      }

      // Sem timeout, uma API pendurada deixa a secao em "carregando" para
      // sempre — sem erro, sem retry, sem nada na tela.
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: AbortSignal.timeout(timeoutMs),
      })

      if (!response.ok) {
        throw new HttpError(response.status, url.toString(), `GET ${url.pathname} respondeu ${response.status}.`)
      }

      return (await response.json()) as T
    },
  }
}
